import React from 'react';
import {Parallax} from 'react-parallax';

const insideStyles = {
    background: "var(--white)",
    padding: 10,
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%,-50%)",
    borderRadius: "5px"
  };

export const ParallaxTitle = ({title}) => {

    return (
        <Parallax bgImage='./assets/images/Start1.jpg' strength={500}>
            <div style={{ height: "250px"}}>
                <div style={insideStyles}>
                    <h1 className="fablab-title">{title}</h1>
                </div>
            </div>
        </Parallax>             
    )
}
